import { useCallback, useEffect } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import './OnboardBiometricLogin.css';

export function OnboardBiometricLogin({ closePopup }: { closePopup: () => Promise<void> }) {
  const { t } = useTranslation();

  const switchBiometric = useCallback(
    (v: string) => {
      localStorage.setItem('biometriclogin', v);
      closePopup();
    },
    [closePopup]
  );

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined = setTimeout(() => {
      switchBiometric('off');
      timer = undefined;
    }, 8000);

    return () => timer && clearTimeout(timer);
  }, [switchBiometric]);

  return (
    <div className="biometric-page">
      <div className="biometric-page-title">{t('onboarding.biometric.title')}</div>
      <div className="biometric-page-subtitle">{t('onboarding.biometric.subtitle')}</div>

      <div className="biometric-page-subtitle">{t('onboarding.biometric.subtitle2')}</div>

      <div>
        <Button
          onClick={() => switchBiometric('true')}
          variant="contained"
          color="secondary"
          type="submit"
          sx={{ color: 'white', borderRadius: 28 }}
        >
          {t('onboarding.biometric.ok')}
        </Button>
      </div>

      <div className="biometric-page-smalltext">
        <a onClick={() => switchBiometric('off')}>{t('onboarding.biometric.notok')}</a>
      </div>
    </div>
  );
}
